import React from 'react'
import { useTheme } from '../../contexts/ThemeContext'

interface LogoProps {
  className?: string
  alt?: string
}

export const Logo: React.FC<LogoProps> = ({ 
  className = "h-10 w-auto transition-transform group-hover:scale-105",
  alt = "Open1031"
}) => {
  const { resolvedTheme } = useTheme()
  const logoSrc = resolvedTheme === 'dark' ? '/logo_white.png' : '/logo.png'

  // Extract height from className if present, otherwise use default
  const heightMatch = className.match(/h-(\d+)/)
  const height = heightMatch ? `${parseInt(heightMatch[1]) * 0.25}rem` : '2.5rem'

  return (
    <img 
      src={logoSrc} 
      alt={alt} 
      className={className}
      style={{ height }} // Ensure consistent height between light and dark mode
    />
  )
}

